import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the qualitativeQuestionList state domain
 */

const selectQualitativeQuestionListDomain = (state) =>
  state.get("qualitativeQuestionList", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoadingAnswers = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("isLoadingAnswers")
  )

export const makeSelectAnswers = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("answers")
  )
/**
 * Default selector used by QualitativeQuestionList
 */

const makeSelectQualitativeQuestionList = () =>
  createSelector(selectQualitativeQuestionListDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectQualitativeQuestionList
export { selectQualitativeQuestionListDomain }
